import React, { useState, useEffect } from "react";
import {
  DateInput,
  TextInput,
  SelectInput,
  FileInput,
  RadioInput,
} from "../../components/common/ui/Inputs";
import Button from "../../components/common/ui/Button";
import documentsSchema from "../../validation/documentsSchema";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication.js";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { documentsActions, masterActions, authActions } from "../../_store";
import { history } from "../../_helpers";
import CustomLoader from "./../../components/common/ui/Loader";
import { useRef } from "react";
import { MenuItem } from "../../_helpers/enumerator";
import { StoredProcedures } from "../../_helpers/enumerator";

function AddorUpdateDocument() {
  const user = useSelector((x) => x.auth.user);
  const dispatch = useDispatch();
  const commonFacilityCode = useSelector((x) => x.auth?.commonFacilityCode);
  const { Status } = useSelector((state) => state.dropdownOptions);
  const location = useLocation();
  const {
    insertdataResponse,
    updatedataResponse,
    griddata,
    documentSearch,
    loading,
  } = useSelector((x) => x.documents);

  //Management User Access Permission selector
  const userAccessPermission = useSelector(
    (state) => state.auth.managementUserAccessPermission
  );
  const { facilityCode, row } = location.state || {};
  const MAX_FILE_SIZE = parseInt(process.env.REACT_APP_MAX_FILESIZE, 10);

  const [documentinformation, setdocumentinformation] = useState({
    documentTitle: "",
    documentName: "",
    documentID: 0,
    activeStatus: 1,
    DocumentPath: "",
    base64Data: "",
    facilityID: commonFacilityCode,
    createdBy: user?.ManagementUserID,
    facilityCode: facilityCode,
    folderPath: "",
    filename: "",
    file: "",
  });
  const [errorMessage, setErrorMessage] = useState({});
  const isEditMode = griddata?.DocumentTitle ? true : false;
  const [accessPermission, setAccessPermission] = useState([]);
  const [accessPermissionRdoBtn, setAccessPermissionRdoBtn] = useState([]);

  // Enabled or Disabled Upload
  const shouldEnableUpload =
    Array.isArray(accessPermission) && accessPermission.length > 0
      ? accessPermission.some(
        (item) =>
          item?.SubMenuName === "Upload" && item?.SubMenuActiveStatus === 1
      )
      : true;

  // Enabled or Disabled Active Radio btn
  const shouldEnableActiveRdoBtn =
    Array.isArray(accessPermission) && accessPermission.length > 0
      ? accessPermission.some(
        (item) =>
          item?.SubMenuName === "Activate" && item?.SubMenuActiveStatus === 1
      )
      : true;

  // Enabled or Disabled InActive Radio btn
  const shouldEnableInActiveRdoBtn =
    Array.isArray(accessPermission) && accessPermission.length > 0
      ? accessPermission.some(
        (item) =>
          item?.SubMenuName === "Deactivate" &&
          item?.SubMenuActiveStatus === 1
      )
      : true;

  // Load facility dropdown on component mount
  const prevFacilityCodeRef = useRef(commonFacilityCode);

  useEffect(() => {
    if (prevFacilityCodeRef.current !== commonFacilityCode) {
      history.navigate("DocumentList");
    }
  }, [commonFacilityCode]);

  useEffect(() => {
    dispatch(
      masterActions.LoadFacilityDropDown({
        facilityID: 0,
      })
    );
  }, []);

  useEffect(() => {
    if (row?.DocumentID) {
      dispatch(documentsActions.GetDocumentDetails(row?.DocumentID));
    }
  }, [row?.DocumentID]);

  // bind the griddata
  useEffect(() => {
    if (griddata && Object.keys(griddata).length > 0) {
      setdocumentinformation({
        ...documentinformation,
        documentTitle: griddata?.DocumentTitle || "",
        activeStatus: parseInt(griddata?.ActiveStatus),
        DocumentPath: griddata?.DocumentPath || "",
        documentName: griddata?.DocumentFileName || "",
      });
    }
  }, [griddata]);

  /// update response
  const handleResponse = (updatedataResponse) => {
    switch (updatedataResponse) {
      case 2:
        // Insert Management User Activity Log
        dispatch(
          authActions?.ManagementUserActivityLog({
            ManagementUserID: user?.ManagementUserID,
            facilityID: commonFacilityCode,
            ProcedureName: StoredProcedures?.DocumentUpdate,
            UserAction: `Updated  Details in Document ( DocumentID - ${documentinformation?.documentID})`,
          })
        );
        history.navigate("/Admin/DocumentList");
        showToastNotification("Document updated successfully", "success");
        // const searchData = { ...documentSearch };
        // searchData.facilityID = commonFacilityCode;
        // searchData.pageNo = 1;
        // searchData.rowCountPerPage = 10;
        // dispatch(documentsActions?.setDocumentSearch(searchData));
        dispatch(documentsActions.clearUpdateDocument());
        //dispatch(documentsActions.clearDocuments());
        break;

      case -1:
        showToastNotification("Unable to update.Please try again", "error");
        dispatch(documentsActions.clearUpdateDocument());
        break;

      case -2:
        showToastNotification("Document not exists", "error");
        dispatch(documentsActions.clearUpdateDocument());
        break;
      case -3:
        showToastNotification("Document Title Already Exists", "error");
        //   dispatch(documentsActions.clearUpdateDocument());
        break;
      default:
        break;
    }
  }

  /// insert response
  useEffect(() => {
    switch (insertdataResponse) {
      case 1:
        // Insert Management User Activity Log
        dispatch(
          authActions?.ManagementUserActivityLog({
            ManagementUserID: user?.ManagementUserID,
            facilityID: commonFacilityCode,
            ProcedureName: StoredProcedures?.DocumentUpload,
            UserAction: `Saved New Document Details ( DocumentTitle - ${documentinformation?.documentTitle})`,
          })
        );
        history.navigate("/Admin/DocumentList");
        showToastNotification("Document uploaded successfully", "success");
        dispatch(documentsActions.clearUploadDocument());
        //dispatch(documentsActions.clearDocuments());

        break;

      case -1:
        showToastNotification("Unable to update.Please try again", "error");
        setdocumentinformation({
          ...documentinformation,
          documentTitle: "",
          documentName: null,
        });
        dispatch(documentsActions.clearUploadDocument());
        break;
      case -3:
        showToastNotification("Document Title Already Exists", "error");
        dispatch(documentsActions.clearUploadDocument());
        break;

      default:
        break;
    }
  }, [insertdataResponse]);

  //Get Management User Access Permission list
  useEffect(() => {
    dispatch(
      authActions.GetManagementUserAccessPermission({
        ManagementUserID: user.ManagementUserID,
        ManagementMenuID: MenuItem.DocumentsMenuItem,
      })
    );
  }, [dispatch]);

  // Management User Access Permission load
  useEffect(() => {
    if (userAccessPermission.length > 0) {
      setAccessPermission(userAccessPermission);
    }
  }, [userAccessPermission]);

  // Management User Access Permission load
  useEffect(() => {
    if (userAccessPermission.length > 0) {
      setAccessPermission(userAccessPermission);
    }
  }, [userAccessPermission]);

  // Update the Radio button list
  useEffect(() => {
    if (Status.length > 0 && accessPermission.length > 0) {
      const updatedStatusArray = Status.map((item) => ({
        ...item,
        disabled:
          item.label === "Active"
            ? !shouldEnableActiveRdoBtn
            : !shouldEnableInActiveRdoBtn,
      }));
      setAccessPermissionRdoBtn(updatedStatusArray);
    } else {
      setAccessPermissionRdoBtn(Status);
    }
  }, [accessPermission, Status]);

  /// doc Add/update onchange
  const handleChange = (event) => {
    const { name, value } = event?.target;

    setdocumentinformation((prevState) => ({
      ...prevState,
      [name]: parseInt(value),
    }));
  };
  // reset Doc
  const handleDocInformationReset = () => {
    if (row && Object?.keys(row)?.length > 0) {
      setdocumentinformation((prevState) => ({
        ...prevState,
        documentTitle: prevState?.documentTitle,
        documentName: prevState?.documentName,
        filename: "",
        base64Data: "",
      }));
      dispatch(documentsActions.GetDocumentDetails(griddata.DocumentID));
    } else {
      setdocumentinformation({
        ...documentinformation,
        documentTitle: "",
        documentName: null,
      });
    }

    // Clear error messages
    setErrorMessage({});

    // Remove input error styling
    // const inputErrorElements = document?.querySelectorAll(".input-error");
    // inputErrorElements?.forEach((input) => {
    //   input.classList.remove("input-error");
    // });
  };

  const handleBlur = () => {
    if (documentinformation?.documentTitle?.trim()?.length == 0) {
      setErrorMessage((prev) => ({
        ...prev,
        ["documentTitle"]: "Please enter Title.",
      }));
    }
  };

  // Add/Upd Doc
  const handleSaveDoc = (e) => {
    e.preventDefault();
    setErrorMessage({});
    // if (document?.getElementsByClassName("input-error").length !== 0) {
    //   document.querySelector(".input-error").classList.remove("input-error");
    // }
    const { error } = documentsSchema(documentinformation);
    if (error?.details) {
      error?.details?.forEach((e) => {
        const { path } = e;
        // Set the error message for each invalid field
        setErrorMessage((prev) => ({
          ...prev,
          [path.toString()]: e.message,
        }));

        // Safely select the input element by name
        // const inputElement = document.querySelector(`input[name="${path}"]`);
        // if (inputElement) {
        //   // Add the input-error class if the element exists
        //   inputElement.classList.add("input-error");
        // }
      });
      return;
    }
    //dispatch(documentsActions.clearGetDocumentDetails());
    switch (row && Object?.keys(row)?.length > 0) {
      //update
      case true:
        // setdocumentinformation({
        const updatedDocumentInfo = {
          ...documentinformation,
          documentID: griddata?.DocumentID,
          documentTitle: documentinformation?.documentTitle,
          documentName: documentinformation?.documentName,
          DocumentPath: documentinformation?.base64Data
            ? ""
            : griddata.DocumentPath,
          base64Data: documentinformation?.base64Data || "",
          facilityCode: facilityCode,
          folderPath: "",
          filename: documentinformation?.filename,
          file: "",
        };

        dispatch(documentsActions.UpdateDocument(updatedDocumentInfo)).then((x) => handleResponse(x?.payload));
        break;
      // insert
      default:
        const InsertDocumentInfo = {
          ...documentinformation,
          facilityID: commonFacilityCode,
          documentTitle: documentinformation?.documentTitle,
          documentName: documentinformation?.documentName,
          base64Data: "",
          file: documentinformation?.base64Data,
          createdBy: user?.ManagementUserID,
          facilityCode: facilityCode,
        };
        dispatch(documentsActions.UploadDocument(InsertDocumentInfo));
        break;
    }
  };
  // upload pdf file
  const fileUpload = (event) => {
    const file = event?.target?.files[0]; // Get the selected file
    if (file === undefined) {
      setErrorMessage((prev) => ({
        ...prev,
        ["documentName"]: "Please upload Document.",
      }));
      setdocumentinformation((prev) => ({
        ...prev,
        documentName: "",
        filename: "",
        file: "",
        // base64Data: base64Data,
      }));
      return;
    }
    // Clear error messages
    // setErrorMessage({});
    // Remove input error styling
    // const inputErrorElements = document?.querySelectorAll(".input-error");
    // inputErrorElements?.forEach((input) => {
    //   input.classList.remove("input-error");
    // });
    const maxSize = MAX_FILE_SIZE; // 25MB file size limit

    // Case for invalid file type (not a PDF)
    // case file.type !== "application/pdf":
    //   showToastNotification("Please upload a valid PDF file", "error");
    //   event.target.value = ""; // Clear the file input if invalid
    //   return;

    // Case for file size exceeding 20MB limit
    if (file?.size > maxSize) {
      showToastNotification("File size exceeds the 20MB limit", "error");
      event.target.value = ""; // Clear the file input if too large
      return;
    }
    // Default case for valid file
    // File is valid, proceed with reading the file
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64Data = reader?.result?.split(",")[1]; // Extract base64 data

      const name = file?.name.substring(0, file?.name.lastIndexOf("."));
      const extension = file?.name.substring(file?.name.lastIndexOf("."));

      const now = new Date();
      const timestamp = now.getFullYear().toString() +
        String(now.getMonth() + 1).padStart(2, "0") +
        String(now.getDate()).padStart(2, "0") +
        String(now.getHours()).padStart(2, "0") +
        String(now.getMinutes()).padStart(2, "0") +
        String(now.getSeconds()).padStart(2, "0");

      const newFileName = `${name}_${timestamp}${extension}`;


      // Update the state with the file name and base64 data
      setdocumentinformation((prev) => ({
        ...prev,

        documentName: newFileName, // Set the document name
        filename: newFileName,
        file: base64Data,
        base64Data: base64Data, // Set the base64-encoded data
      }));
      setErrorMessage((prev) => ({
        ...prev,
        documentName: "", // Clear the error message for documentName field
      }));
    };

    reader?.readAsDataURL(file); // Read the file as base64
    // break;
    // }
  };
  // Doc onChange
  const handleDocumInformationChange = (e) => {
    const { name, value } = e.target;

    const regex = /^[a-zA-Z0-9\s]*$/;

    if (!regex.test(value)) {
      return;
    }

    if (value.trim() === "" && value !== "") {
      return;
    }
    setErrorMessage((prev) => ({
      ...prev,
      [name]: "",
    }));
    // Remove input error styling
    // const inputErrorElements = document?.querySelectorAll(".input-error");
    // inputErrorElements?.forEach((input) => {
    //   input.classList.remove("input-error");
    // });

    setdocumentinformation((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    //  setErrorMessage({});
    //  if (document?.getElementsByClassName("input-error").length !== 0) {
    //    document.querySelector(".input-error").classList.remove("input-error");
    //  }
    //  const { error } = documentsSchema(documentinformation);

    //  if (error?.details) {
    //    error?.details?.forEach((e) => {
    //      const { path } = e;
    //      // Set the error message for each invalid field
    //      setErrorMessage((prev) => ({
    //        ...prev,
    //        [path.toString()]: e.message,
    //      }));

    //      // Safely select the input element by name
    //      const inputElement = document.querySelector(`input[name="${path}"]`);
    //      if (inputElement) {
    //        // Add the input-error class if the element exists
    //        inputElement.classList.add("input-error");
    //      }
    //    });
    //    return;
    //  }
  };
  // back to grid page
  const handleBack = () => {
    history.navigate("/Admin/DocumentList");
    dispatch(documentsActions.clearGetDocumentDetails());
    dispatch(documentsActions.clearUploadDocument());
  };

  if (loading) {
    return <CustomLoader />;
  }

  return (
    <>
      <div className="card  shadow-sm b-r-all  p-4 border border-dark-grey mt-3  w-100">
        <div className="d-flex flex-wrap justify-content-between align-items-center flex-wrap mb-2">
          <h2 className="form_title_uppercase text-color">UPLOAD DOCUMENT</h2>
          <Button
            label="Back"
            type="button"
            //className="btn btn-danger"
            onClick={handleBack}
            variant="danger"
            status={"primary"}
            disabled={false}
            icon={"fa-solid fa-angle-left"}
          />
        </div>

        <div className="mt-2">
          <h4 className="inner-header-bg text-color">
            {" "}
            <i className="fa-solid fa-circle-info me-2"></i> Document
            Information{" "}
          </h4>
          <div>
            <form>
              <div className="row col-lg-12">
                <div className="mb-3 col-sm-6 col-lg-6">
                  <TextInput
                    name="documentTitle"
                    label="Title"
                    value={documentinformation?.documentTitle}
                    handleChange={handleDocumInformationChange}
                    placeholder="Title"
                    required={true}
                    errorMessage={errorMessage}
                    maxLength={50}
                    handleBlur={handleBlur}
                  />
                </div>

                <div className="mb-1 col-sm-6 col-lg-6">
                  <FileInput
                    label="Document"
                    name="documentName"
                    showImage={false}
                    handleFileChange={fileUpload}
                    value={documentinformation?.documentName}
                    acceptFormat=".pdf"
                    required={shouldEnableUpload}
                    errorMessage={errorMessage}
                    disabled={!shouldEnableUpload}
                  />

                  <div className="fs-5 text-gray">
                    <span className="text-gray">
                      Note: Accepted Document Format pdf only
                    </span>
                  </div>
                </div>
              </div>
              <div className="row col-lg-12">
                {isEditMode && (
                  <div className="mb-3 col-lg-6 ">
                    <label
                      className="form-label col-form-label col-md-3 w-100 fs-5 custom-color font-weight-normal"
                      style={{ color: "#111827" }}
                    >
                      Document Name
                    </label>
                    <b className="doc-name">
                      {" "}
                      <i class="fa-solid fa-file-lines me-2 color-document"></i>
                      {griddata?.DocumentFileName}
                    </b>
                  </div>
                )}

                {isEditMode && (
                  <div className="col-md-4 mt-2 col-lg-6">
                    <RadioInput
                      name="activeStatus"
                      id="activeStatus"
                      label="Status"
                      selectedValue={documentinformation?.activeStatus}
                      handleChange={handleChange}
                      options={accessPermissionRdoBtn}
                    />
                  </div>
                )}
              </div>
              <div className="mt-3 d-flex flex-wrap justify-content-center gap-3">
                <Button
                  className="me-2"
                  label={isEditMode ? "Update" : "Save"}
                  type="submit"
                  variant="danger"
                  status={"success"}
                  onClick={(e) => handleSaveDoc(e)}
                  disabled={false}
                  icon={
                    isEditMode
                      ? "fa-solid fa-pen-to-square"
                      : "fa-solid fa-floppy-disk"
                  }
                />
                <Button
                  className="me-2"
                  label="Reset"
                  type="reset"
                  variant="danger"
                  status={"secondary"}
                  onClick={handleDocInformationReset}
                  disabled={false}
                  icon={"fa-solid fa-rotate-right"}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default React.memo(AddorUpdateDocument);
